export const commonEn = {
  na: "N/A",
  itemSwappedOut: "Item Swapped Out:",
  itemSwappedIn: "Item Swapped In:",
  facingsChange: "Facings:",
  swapFacingsModeLabel: "Facings Mode",
  swapFacingsModeMatch: "Match swap-out facings",
  swapFacingsModeFree: "Let DOS balancing decide",
  multiplePlacementFailures: "Multiple placement failures",
  updateReport: {
    facingsExpanded: "FACINGS EXPANDED",
    facingsReduced: "FACINGS REDUCED",
    item: "ITEM",
    items: "ITEMS",
  },
  search: "Search",
  close: "Close",
  cancel: "Cancel",
  save: "Save",
  delete: "Delete",
  edit: "Edit",
  view: "View",
  back: "Back",
  next: "Next",
  loading: "Loading...",
  noResults: "No results found",
  storePogExport: {
    forceOverwritePdfs: "Force overwrite PDFs",
    latestVersionNote: "Exports each store's latest planogram, not the version shown.",
    approvedVersionNote:
      "Exports the approved planogram for each store, whichever version was approved.",
    csvColumns: {
      title: "Choose CSV columns",
      rangedItems: "Ranged Items",
      unrangedItems: "Unranged Items",
      loading: "Loading columns...",
      loadFailed: "CSV columns could not be loaded. Try again.",
      loadFailedToast: "Failed to load CSV export columns",
      retry: "Retry",
      search: "Search columns",
      selectedCount: "{{selected}} of {{total}} columns selected",
      noMatches: "No columns match your search.",
      export: "Export CSV",
    },
  },
  download: "Download",
  generate: "Generate",
  status: "Status",
  category: "Category",
  store: "Store",
  stores: "Stores",
  cluster: "Cluster",
  brand: "Brand",
  critical: "Critical",
  warning: "Warning",
  medium: "Medium",
  low: "Low",
  active: "Active",
  shelves: "Shelves",
  start: "Start: {{date}}",
  end: "End: {{date}}",
  alerts: "Alerts ({{count}})",
  before: "Before",
  after: "After",
  change: "Change",
  current: "Current",
  salesValue: "Sales Value",
  unitsSold: "Units Sold",
  grossMargin: "Gross Margin",
  inventoryTurnover: "Inventory Turnover",
  daysOfInventory: "Days of Inventory",
  outOfStock: "Out of Stock (%)",
  pareto: "Pareto 80/20",
  premium: "Premium",
  urban: "Urban",
  suburban: "Suburban",
  language: "Language",
  shelf: "Shelf",
  selectedShelves: "Selected Shelves",
  selectedShelf: "Selected Shelf",
  shelvesCount: "{{count}} shelves",
  shelfName: "Shelf: {{name}}",
  shelfNotchPrefix: " N:{{notch}}",
  shelfEditor: {
    label: "Shelf editor",
  },
  shelfTypes: {
    label: "Shelf type",
    regular: "Regular",
    riser: "Riser",
    hangCell: "Hang Cell",
    setFailed: "Failed to set shelf type",
  },
  // Weight vocabulary: a board's maximum load is its LIMIT, never its
  // "capacity" — capacity already means units on this screen.
  planogramRules: {
    weightRules: {
      tab: "Weight",
      shelfCap: {
        title: "Shelf load limit",
        limit: "Maximum load per shelf (grams)",
        pounds: "{{pounds}} lb",
        noCap: "No cap — shelves are reported but not judged",
      },
      heavyRule: {
        title: "Heavy items sit low",
        threshold: "Heavy at or above (grams)",
        thresholdPounds: "{{pounds}} lb",
        maxDeckY: "Height line",
        maxDeckYHelp:
          "A coordinate in the same scale as your fixture geometry, read off the planogram. Not millimetres, not inches — the same numbers your bays and shelves already use.",
        maxDeckYRequired:
          "Required — there is no safe default. Read this off your own fixtures; this rule stays off until you enter one.",
      },
      passes: {
        resolveTitle: "Overweight shelves",
        resolve: "Resolve overweight shelves",
        resolveHelp:
          "Trim depth on shelves over the cap, never below an item's supply floor; then delist the worst value-per-weight product until the shelf is under its cap.",
        swapTitle: "Heavy brand placement",
        swap: "Swap heavy brands low",
        swapHelp:
          "Exchange whole brand blocks between a high and a low shelf so heavy product sits below the height line, keeping each brand contiguous.",
        swapNeedsHeavyRule: 'Turn on "Heavy items sit low" to give this rule its numbers.',
      },
      advanced: {
        title: "Advanced",
        blockLevel: "Brand block level",
        blockLevelHelp:
          "Which CDT level names a brand for the swap. Laundry carries brand at cdt2; another category may differ.",
        fillFloor: "Minimum fill kept after a swap",
      },
    },
  },
  shelfWeight: {
    label: "Weight",
    load: "{{pounds}} lb",
    // Provenance: a stated weight and a guessed one must not read alike. The
    // note names the weakest evidence in the total — see shelfWeightLabel.ts.
    loadWithNotes: "{{pounds}} lb ({{notes}})",
    measured: "measured",
    allDerived: "derived",
    someDerived: "{{count}} derived",
    unweighed: "{{count}} unweighed",
    bulk: "BULK",
    overloadedLabel: "Overloaded",
    overloadedRequestDefault: "over the {{pounds}} lb limit set for this run",
    overloadedFixture: "over the fixture's {{pounds}} lb limit",
    limitLabel: "Weight limit",
    noLimit: "no weight limit set for this run",
    pogTotal: "Total Weight",
  },
  widthFormatted: "{{value}} m {{cm}} cm",
  preparedBy: "Prepared By",
  approvedBy: "Approved By",
  categoryOwner: "Category Owner",
  dateEffective: "Date Effective",
  segment: "Segment",
  page: "Page",
  newItemSummary: "New Item Summary",
  deletedItemSummary: "Deleted Item Summary",
  shelfSemanticReport: "Shelf Semantic Report",
  width: "Width",
  depth: "Depth",
  height: "Height",
  highlights: {
    defaultInsertedItemName: "New Inserted Item",
    newItemBadge: "PI",
    itemWeight: "Item Weight",
    itemWeightSublabel: "lb on shelf",
    shelfWeight: "Shelf Weight",
    shelfWeightSublabel: "lb on board",
    shelfWeightPct: "Shelf Weight %",
    shelfWeightPctSublabel: "of limit",
    overloaded: "Overloaded",
    overloadedSublabel: "over limit",
  },
  planogramCanvas: {
    rendererToggle: "Canvas renderer",
    itemCount: "{{count}} items",
    newItemIndicator: "New item indicator",
    itemMenu: {
      delete: "Delete",
      duplicate: "Duplicate",
      flipHorizontally: "Flip Horizontally",
      sideView: "Side View",
      unrange: "Unrange",
    },
    bayMenu: {
      addBayLeft: "Add Bay Left",
      addBayRight: "Add Bay Right",
      deleteBay: "Delete Bay",
      newShelf: "New Shelf",
      title: "Bay {{bayNo}}",
    },
    containerMenu: {
      delete: "Delete",
      splitBottom: "Split to Bottom",
      splitRight: "Split to Right",
      unrange: "Unrange",
    },
    shelfMenu: {
      delete: "Delete",
      duplicate: "Duplicate",
      flipHorizontally: "Flip Horizontally",
      mergeLeft: "Merge left",
      mergeRight: "Merge right",
      moveDown: "Move down",
      moveUp: "Move up",
      sortCdt1: "Sort by CDT1 Priority",
      sortCdt2: "Sort by CDT2 Priority",
      sortCdt3: "Sort by CDT3 Priority",
      unmergeLeft: "Unmerge left",
      unmergeRight: "Unmerge right",
      viewUnranged: "View Unranged",
    },
  },
  planogramMetrics: {
    returnOnSpace: {
      title: "Return on Space",
      description:
        "Whether each part of the category gets shelf space in line with what it sells. A high score means nothing is starved — giving a group more room than it earns is not marked down.",
    },
    coreRange: {
      title: "Core Range",
      description:
        "How many of your must-stock products actually made it onto the shelf. Extra facings of the same product count once.",
      emptyReason:
        "No products on this plan are flagged as core range, so there is nothing to measure against.",
    },
    shelfAlignment: {
      title: "Shelf Alignment",
      description:
        "Whether shelves line up at the same height as you look along the fixture, bay to bay. Shelves that are close but not level count as a miss.",
    },
    dosMos: {
      title: "DOS / MOS",
      description:
        "How many products hold enough stock on shelf to keep trading between deliveries. A product counts against the score if it misses either its days-of-supply or its units-on-shelf target.",
    },
    aesthetics: {
      title: "Aesthetics",
      description:
        "How tidy and shoppable the plan looks: clean blocks, the category's own order, full shelves, heavy packs low. It says nothing about sales, so read it alongside the numbers that do.",
    },
    expectedSales: {
      title: "Expected Sales",
      description:
        "What everything on this plan is expected to sell, added up — counted once per product, whatever its facings. Read it against the scores to its left: a tidier plan that drops products looks better there and worse here.",
      emptyReason:
        "This plan has no real sales figures against it — every product carries the same placeholder, so a total would be a made-up number. Re-run the data load to bring sales in.",
    },
  },
  planogramProductDetails: {
    bulkWeight: "{{weight}} lb · BULK",
    weight: "Weight",
    weightValue: "{{weight}} lb",
  },
  pegboardFacingChange: {
    indicator: "Facing update: {{changeType}}",
    inserted: "Inserted",
    swappedIn: "Swapped in",
    facingsIncreased: "Facings increased",
    facingsDecreased: "Facings decreased",
    swappedOut: "Swapped out",
    deleted: "Deleted",
  },
  editShelfModal: {
    menuLabel: "Edit shelf",
    multipleShelvesEditUnavailable: "Edit shelf is only available when one shelf is selected.",
    title: "Edit shelf",
    widthLabel: "Shelf width (inches)",
    widthPlaceholder: "Enter shelf width",
    mergedWidthDisabled: "Width cannot be changed for merged shelves.",
    merchandisableWidthLabel: "Merchandisable width (inches)",
    merchandisableWidthPlaceholder: "Enter merchandisable width",
    mergedMerchandisableWidthDisabled: "Merchandisable width cannot be changed for merged shelves.",
    merchandisableSpaceLabel: "Merchandisable space",
    invalidWidth: "Please enter a valid positive number for shelf width.",
    invalidMerchandisableWidth: "Please enter a valid merchandisable width within the shelf width.",
    alignLabel: "Shelf alignment",
    alignLeft: "Left",
    alignRight: "Right",
    alignBetween: "Between",
    alignAround: "Around",
    changeShelfTypeTitle: "Change shelf type to {{shelfType}}?",
    incompatibleProductDescriptionOneShelf:
      "1 product on this shelf can't be merchandised on a {{shelfType}} fixture ({{names}}). Saving will move it to the unranged list.",
    incompatibleProductDescriptionMultipleShelves:
      "1 product on these shelves can't be merchandised on a {{shelfType}} fixture ({{names}}). Saving will move it to the unranged list.",
    incompatibleProductsDescriptionOneShelf:
      "{{count}} products on this shelf can't be merchandised on a {{shelfType}} fixture ({{names}}). Saving will move them to the unranged list.",
    incompatibleProductsDescriptionMultipleShelves:
      "{{count}} products on these shelves can't be merchandised on a {{shelfType}} fixture ({{names}}). Saving will move them to the unranged list.",
    incompatibleProductsAndMore: "and {{count}} more",
    changeAndUnrange: "Change & Unrange",
  },
  cdtTreeEditor: {
    button: "CDT Tree",
    loadingCategory: "Loading Category CDT Tree...",
    categoryLoadFailed: "Failed to load Category CDT Tree",
    invalidCategory: "The category ID is invalid.",
    saveSuccess: "CDT Hierarchy saved successfully!",
    saveFailed: "Failed to save CDT hierarchy",
    saveUnavailable: "This local CDT draft cannot be saved to the API.",
    saveNewUnavailable: "Saving a new CDT hierarchy is not available yet.",
    nextUnavailable: "Next navigation is not available yet.",
    resetSuccess: "CDT hierarchy reset to ETL data.",
    resetFailed: "Failed to reset CDT hierarchy.",
    resetRefreshFailed:
      "Reset succeeded, but the refreshed hierarchy could not be loaded. Reload the page to continue.",
    unassigned: "(Unassigned)",
  },
  cdtWarnings: {
    nodeNameBlank: "Node name cannot be blank.",
    subgroupNameBlank: "Subgroup name cannot be blank.",
    cannotAddBelow: "A subgroup cannot be added below CDT3.",
    saveParentFirst: "Save the new parent before adding another subgroup.",
    cdt0CannotReparent: "CDT0 nodes cannot be reparented.",
    cannotReparentIntoSubtree: "A node cannot be reparented into its own subtree.",
    nodeNotFound: "Node {{node}} was not found.",
    parentNotFound: "Parent node {{node}} was not found.",
    invalidReorder: "The reorder references an invalid node.",
    reorderSiblings: "Reordering is only valid between siblings under the same parent.",
    invalidMerge: "The merge references an invalid node.",
    invalidNodeParent: "The node or parent reference is invalid.",
    targetParentLevel: "The target parent must be {{expected}}, but is {{actual}}.",
    renameCollision: "A rename collision was detected with node {{node}}.",
  },
  cdtTable: {
    hierarchyNode: "Hierarchy Node",
    productCount: "Product Count",
    alerts: "Alerts",
    reorder: "Reorder",
    products: "products",
    clean: "Clean",
    prioritySequence: "Priority Sequence",
    priorityDescription: "Derived minimum descendant product priority",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    fitView: "Fit to view",
    productCountValue: "{{count}} products",
  },
  cdtHeader: {
    tree: "Tree",
    list: "List",
    priority: "CDT Priority",
    undo: "Undo",
    redo: "Redo",
    save: "Save",
    togglePriority: "Toggle priority badges",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    resolveAlerts: "Resolve alerts",
    category: "CDT 0: Category",
    categoryName: "Category",
    segmentName: "Segment",
    brandName: "Brand",
    flavourName: "Flavour",
    revertChanges: "Revert changes",
    saveNew: "Save new",
    next: "Next",
  },
  cdtRename: {
    title: "Rename Group Collision",
    existing: 'A sibling group named "{{name}}" already exists!',
    mergeDescription: "Renaming will merge these two groups and combine their descendant subtrees.",
    cancel: "Cancel",
    close: "Close rename collision dialog",
    confirm: "Confirm Merge",
  },
  cdtDelete: {
    title: "Delete Subtree Confirmation",
    question: 'Are you sure you want to delete group "{{name}}"?',
    descendants: "Descendant CDT nodes to be removed:",
    close: "Close delete confirmation",
    cancel: "Cancel",
    delete: "Delete Subtree",
  },
  cdtReset: {
    title: "Reset to ETL data",
    warning: "This discards saved customization and unsaved hierarchy edits.",
    close: "Close reset confirmation",
    cancel: "Cancel",
    confirm: "Reset to ETL",
    resetting: "Resetting…",
  },
  cdtCanvas: {
    categoryRoot: "Category",
    selectNode: "Select {{name}}",
    expandNode: "Expand {{name}}",
    collapseNode: "Collapse {{name}}",
    moveUp: "Move up",
    moveDown: "Move down",
  },
  cdtNodeInspector: {
    title: "Node Inspector",
    group: "Group",
    categoryRoot: "Category Root",
    nodeName: "Node Name",
    aggregateItemCount: "Items in hierarchy, including descendants ({{count}})",
    immediateChildren: "Immediate children",
    noImmediateChildren: "No immediate children.",
    viewProducts: "View products",
    saveBeforeViewingProducts: "Save the hierarchy before viewing products.",
    addSubgroup: "Add {{level}} Subgroup",
    newGroupName: "New {{level}} group name",
    addSubgroupAction: "Add Subgroup",
    deleteGroup: "Delete this group",
    activeAlerts: "Active Alerts ({{count}})",
    noActiveAlerts: "No active alerts for this node.",
    suggestionsComingSoon: "Suggestions (Coming soon)",
    comingSoon: "Coming soon",
    selectNode: "Select a node on the canvas to inspect details.",
    submitRename: "Submit rename",
    saveParentFirst: "Save the new parent before adding another subgroup",
  },
  cdtProducts: {
    regionLabel: "Products in {{name}}",
    title: "Products in {{name}}",
    directCountOne: "1 direct product",
    directCount: "{{count}} direct products",
    searchPlaceholder: "Search products",
    close: "Close products drawer",
    loading: "Loading products…",
    loadFailed: "Products could not be loaded.",
    retry: "Retry",
    noProducts: "No products are assigned directly to this node.",
    noSearchResults: "No products match this search.",
    pageSize: "Rows per page",
    product: "Product",
    segment: "Segment",
    subcategory: "Subcategory",
    brand: "Brand",
    sku: "SKU",
    price: "Price",
    position: "Position",
    notAvailable: "Not available",
  },
  cdtAlerts: {
    renamePlaceholder: "New name...",
    rename: "Rename",
    groupScope: "Group: {{name}}",
    draftScope: "Draft-level alerts",
    affectedGroup: "Affected group: {{name}}",
    affectedDraft: "Affected scope: current draft",
    similarGroup: 'Similar CDT group name "{{name}}" under the same parent',
    guidedTitle: "Guided Alert Resolution",
    close: "Close alert resolution",
    similarGroups: "Similar Groups:",
    affectedScope: "Affected scope",
    affectedAlertScope: "Affected alert scope",
    allActive: "All active alerts",
    showing: "Showing {{shown}} of {{total}} active alerts",
    noAlerts: "No active CDT hierarchy alerts!",
    noScopedAlerts: "No active alerts in this affected scope.",
    focusGroup: "Focus group",
    editRequired: "Edit mode required for repair",
  },
  cdtStudioTab: {
    tabLabel: "CDT Studio",
    configurationLabel: "CDT Studio configuration",
    unavailable: {
      notPlanogram: "CDT Studio is available only in a Planogram Editor.",
      missingMerchflow: "Open this planogram from a merchflow to use CDT Studio.",
      unsupportedMerchant: "CDT Studio is currently available only for Walmart.",
      missingPermission: "Your role needs CDT edit permission to use CDT Studio.",
      categoryUnavailable:
        "CDT Studio needs exactly one category in the current planogram context.",
      configurationRequired:
        "No CDT Studio configuration is available for this category. Open Categories and save the configuration for this category.",
    },
  },
  planogramHighlights: {
    pinLabelToTop: "Pin {{label}} to top",
    unpinLabel: "Unpin {{label}}",
  },
  cdtPriorityOrder: {
    tabLabel: "Re-order CDTs",
    cdtLevel: "CDT Level",
    cdt0: "CDT0",
    cdt1: "CDT1",
    cdt2: "CDT2",
    cdt3: "CDT3",
    searchPlaceholder: "Search CDT or product",
    expandGroup: "Expand {{groupName}}",
    collapseGroup: "Collapse {{groupName}}",
    cdt0NoPriority: "CDT0 uses variant and has no stored priority field",
    productCount: "{{count}} product",
    productCountPlural: "{{count}} products",
    unplaced: "Unplaced",
    includesUnplaced: "Includes unplaced",
    ranged: "Ranged",
    unranged: "Unranged",
    placementLabel: "Bay {{bayNo}}, Shelf {{shelfNo}}",
    pegboardPlacementLabel: "Pegboard {{pegboardId}}, hole {{holeNoLeft}}, {{holeNoTop}}",
    mixed: "Mixed",
    noCdt: "(No CDT)",
    noData: "No CDT priority data",
    mode: "Mode",
    imageMode: "Image",
    labelMode: "Label",
    productCanvas: "CDT products",
    selectProduct: "Select {{productName}}",
    moveProductLeft: "Move {{productName}} left",
    moveProductRight: "Move {{productName}} right",
    zoom: "Zoom",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    resetZoom: "Reset zoom",
    viewportControls: "Planogram viewport controls",
    resetViewport: "Reset viewport",
    reset: "Reset",
    planogramContainers: "Planogram containers",
    planogramProducts: "Planogram products",
    planogramPegboards: "Planogram pegboards",
    planogramPlacements: "Planogram placements",
    planogramShelves: "Planogram shelves",
    planogramFixtures: "Planogram fixtures",
    selectContainer: "Select {{label}}",
    selectPegboard: "Select pegboard {{id}}",
    selectPlacement: "Select {{label}}",
    selectShelf: "Select shelf {{shelfNo}}",
    selectFixture: "Select {{fixtureName}} {{shelfNo}}",
    shelf: "Shelf {{shelfNo}}",
    fixture: "{{fixtureName}} {{shelfNo}}",
    riserFixture: "riser",
    hangcellFixture: "hangcell",
    moveLeft: "Move left",
    moveRight: "Move right",
    resizeShelfWider: "Resize shelf {{shelfNo}} wider",
    resizeShelfNarrower: "Resize shelf {{shelfNo}} narrower",
    resizeShelfWiderText: "Resize shelf wider",
    resizeShelfNarrowerText: "Resize shelf narrower",
    resizeFixtureNarrower: "Resize {{fixtureName}} {{shelfNo}} narrower",
    resizeFixtureNarrowerText: "Resize fixture narrower",
    resizeFixtureWider: "Resize {{fixtureName}} {{shelfNo}} wider",
    resizeFixtureWiderText: "Resize fixture wider",
    invalidPegboardHole: "Choose an available pegboard hole.",
    shelfCollision: "Move the shelf to an open position.",
    shelfResizeCollision: "Choose a fixture size that does not overlap another fixture.",
    shelfMoveFailed: "The shelf could not be moved. Try another position.",
    shelfResizeFailed: "The fixture could not be resized. Try another size.",
    pegboardMoveFailed: "The product could not be moved on the pegboard. Try another hole.",
    productMoveRejected: "The product could not be moved. Try another position.",
    planogramMoveFailed: "The planogram change could not be completed. Try again.",
    labelOptions: {
      none: "None",
      brand: "Brand",
      categoryCode: "Category code",
      cdt0: "CDT0",
      cdt1: "CDT1",
      cdt1Priority: "CDT1 priority",
      cdt2: "CDT2",
      cdt2Priority: "CDT2 priority",
      cdt3: "CDT3",
      cdt3Priority: "CDT3 priority",
      color: "Color",
      facings: "Facings",
      name: "Name",
      price: "Price",
      productCode: "Product code",
      quantity: "Quantity",
      ranking: "Ranking",
      salesAmount: "Sales amount",
      size: "Size",
      subCategory: "Subcategory",
      upc: "UPC",
      variant: "Variant",
    },
    confirmSnakingAriaLabel: "Confirm snaking pattern",
    snakingPatternAriaLabel: "Snaking pattern configuration",
    confirmSnakingTitle: "Confirm snaking pattern",
    confirmSnakingDescription:
      "Review the inferred row directions and bay row order before enabling CDT editing.",
    snakingPatternTitle: "Snaking pattern configuration",
    snakingPatternDescription: "Review the configured row directions and bay row order.",
    bayLabel: "Bay {{bayNo}}",
    shelfLabel: "Shelf {{shelfName}}",
    bayShelfOrderAriaLabel: "Bay {{bayNo}} shelf order",
    shelfDirectionAriaLabel: "Shelf {{shelfName}} direction",
    pegboardRowLabel: "Pegboard {{pegboardId}}, row {{rowNo}}",
    pegboardRowDirectionAriaLabel: "Pegboard {{pegboardId}}, row {{rowNo}} direction",
    selectShelfOrder: "Select shelf order",
    topFirst: "Top-first",
    bottomFirst: "Bottom-first",
    selectDirection: "Select direction",
    leftToRight: "Left-to-right",
    rightToLeft: "Right-to-left",
    incompleteSnakingConfiguration:
      "Complete every bay and traversal-row direction. All segments of a merged shelf must use the same row direction.",
    confirm: "Confirm",
    snakingUnavailableTitle: "CDT Planogram Editor unavailable",
    snakingUnavailableMessage:
      "REGULAR shelves and pegboards are supported. RISER, HANGCELL, and other unsupported fixtures block the entire CDT Planogram Editor.",
    confirmSnakingBeforeDrag:
      "Confirm the Snaking Pattern configuration before using CDT drag and drop.",
    priorityOrderViolation:
      "Priority Order Violation: Traversal order does not match ascending stored CDT3 priority. Drag and drop is disabled.",
    duplicateCdtPath:
      "Duplicate CDT Path: CDT movement and priority recalculation are disabled until the duplicate is fixed.",
    duplicateCdtPathDetails: "{{path}} — products: {{productCodes}}",
    recalculationFailed:
      "Full Priority Recalculation could not be completed. The planogram is unchanged.",
    productMoveFailed:
      "The product could not be moved because CDT priorities could not be recalculated. The planogram is unchanged.",
    recalculatePriorities: "Full Priority Recalculation",
    viewSnakingPattern: "View Snaking Pattern",
    hideSnakingPattern: "Hide Snaking Pattern",
  },
  unsavedChanges: {
    title: "Unsaved Changes",
    description:
      "You have unsaved changes on this planogram. Save them before leaving, or leave anyway and lose them.",
    keepEditing: "Keep Editing",
    leaveAnyway: "Leave Anyway",
    save: "Save",
    saveFailed: "Failed to save planogram changes",
  },
  productsCdtsChanged: {
    title: "Products CDTs have been changed",
    description:
      "Products CDT changes can be saved only to the base planogram or also update products CDTs for all stores",
    saveOnly: "Save Only",
    saveAndUpdateProducts: "Save and Update Products",
  },
  planogram: {
    facingsAndPlacement: "Facings & Placement",
    assortment: "Assortment",
  },
  basePog: {
    unavailableTitle: "No base planogram",
    unavailableMessage: "This store was imported from PSA and has no base planogram to review.",
  },
  sidebar: {
    performance: "Performance",
    assortment: "Assortment",
    spacePlanning: "Space Planning",
    imagine: "Imagine",
    categories: "Categories",
    stores: "Stores",
    products: "Products",
    fixtures: "Fixtures",
    projects: "Projects",
    merchflows: "Merchflows",
    storeSummary: "Store Summary",
    users: "Users",
    audit: "Audit",
    profile: "Profile",
    settings: "Settings",
    logout: "Log Out",
  },
  storesPickList: {
    columnStore: "STORE",
    columnBaySize: "BAY SIZE",
    columnBusinessType: "BUSINESS TYPE",
    columnActivityType: "ACTIVITY TYPE",
    searchPlaceholder: "Search stores",
    selectedCount: "{{selected}} selected / {{total}} in filter",
    loadingStores: "Loading stores...",
    nextButton: "Next ({{count}} {{label}})",
    storeLabel: "store",
    storesLabel: "stores",
  },
} as const;

export type CommonTranslations = typeof commonEn;
